import { render, staticRenderFns } from "./icon-airport.vue?vue&type=template&id=04877b4c&lang=html"
import script from "./icon-airport.vue?vue&type=script&lang=js"
export * from "./icon-airport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports